<template>
  <div class="ag-radio-button" :data-inline="inline">
    <AGLabel :label="computedLabel" :disabled="disabled">
      <v-radio-group
        v-model="localValue"
        class="ag-radio-button__group"
        color="primary"
        :hide-details="hideDetails"
        :inline="inline"
        :rules="rules"
        :disabled="disabled"
        :readonly="readonly"
        @update:model-value="onUpdate"
      >
        <v-radio
          v-for="(item, key) in items"
          :key="key"
          class="ag-radio-button__item"
          :label="getItemTitle(item)"
          :value="getItemValue(item)"
          :disabled="disabled || item.disabled"
          :readonly="readonly"
        />
      </v-radio-group>
    </AGLabel>
  </div>
</template>

<script>
import AGLabel from '@/components/common/AGLabel.vue';

export default {
  components: { AGLabel },
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: [String, Number, Boolean, null],
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    itemTitle: {
      type: [String, Function],
      default: 'title',
    },
    itemValue: {
      type: [String, Function],
      default: 'value',
    },
    hideDetails: {
      type: [String, Boolean],
      default: 'auto',
    },
    inline: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
    computedLabel() {
      return `${this.label}${this.rules.some((rule) => rule?.name?.toLowerCase().includes('required')) ? ' *' : ''}`;
    },
  },
  methods: {
    getItemTitleKey() {
      return typeof this.itemTitle === 'function' ? this.itemTitle() : this.itemTitle;
    },
    getItemValueKey() {
      return typeof this.itemValue === 'function' ? this.itemValue() : this.itemValue;
    },
    getItemTitle(item) {
      return item[this.getItemTitleKey()];
    },
    getItemValue(item) {
      return item[this.getItemValueKey()];
    },
    onUpdate(val) {
      this.$emit('update:modelValue', val);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/messages.scss';

.ag-radio-button {
  &[data-inline='true'] {
    .ag-radio-button__group {
      ::v-deep(.v-selection-control-group) {
        gap: 16px;
      }
    }
  }

  ::v-deep(.v-input--error) {
    color: $feedback-color-error-medium;
  }
}
</style>
